<template>
  <div v-if="isAlertStatusVisible" class="asc-container">
    <asc-alert-icon :status="status"></asc-alert-icon>
  </div>
</template>

<script>
import { AscStatusPropsMixin } from '@/components/mixins'
import AscAlertIcon from './AscAlertIcon'

export default {
  name: 'AscAlertIconCount',

  components: {
    AscAlertIcon,
  },

  mixins: [AscStatusPropsMixin],

  computed: {
    isAlertStatusVisible() {
      return this.status !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-container {
  display: flex;
}
</style>
